/**
 * Global anchor points for mock seed expansion.
 * Each copy index maps to a different city so map/board data spreads worldwide.
 */
export const WORLD_ANCHORS = [
  { slug: 'seoul', cityTag: 'seoul', regionTag: 'korea', lat: 37.5665, lon: 127.978, planet_id: 1 },
  { slug: 'tokyo', cityTag: 'tokyo', regionTag: 'japan', lat: 35.6762, lon: 139.6503, planet_id: 2 },
  { slug: 'nyc', cityTag: 'nyc', regionTag: 'usa', lat: 40.7128, lon: -74.006, planet_id: 2 },
  { slug: 'london', cityTag: 'london', regionTag: 'uk', lat: 51.5074, lon: -0.1278, planet_id: 3 },
  { slug: 'paris', cityTag: 'paris', regionTag: 'france', lat: 48.8566, lon: 2.3522, planet_id: 3 },
  { slug: 'berlin', cityTag: 'berlin', regionTag: 'germany', lat: 52.52, lon: 13.405, planet_id: 3 },
  { slug: 'rome', cityTag: 'rome', regionTag: 'italy', lat: 41.9028, lon: 12.4964, planet_id: 3 },
  { slug: 'barcelona', cityTag: 'barcelona', regionTag: 'spain', lat: 41.3851, lon: 2.1734, planet_id: 3 },
  { slug: 'amsterdam', cityTag: 'amsterdam', regionTag: 'netherlands', lat: 52.3676, lon: 4.9041, planet_id: 3 },
  { slug: 'dubai', cityTag: 'dubai', regionTag: 'uae', lat: 25.2048, lon: 55.2708, planet_id: 4 },
  { slug: 'mumbai', cityTag: 'mumbai', regionTag: 'india', lat: 19.076, lon: 72.8777, planet_id: 4 },
  { slug: 'singapore', cityTag: 'singapore', regionTag: 'asia', lat: 1.3521, lon: 103.8198, planet_id: 4 },
  { slug: 'bangkok', cityTag: 'bangkok', regionTag: 'thailand', lat: 13.7563, lon: 100.5018, planet_id: 4 },
  { slug: 'sydney', cityTag: 'sydney', regionTag: 'australia', lat: -33.8688, lon: 151.2093, planet_id: 5 },
  { slug: 'melbourne', cityTag: 'melbourne', regionTag: 'australia', lat: -37.8136, lon: 144.9631, planet_id: 5 },
  { slug: 'auckland', cityTag: 'auckland', regionTag: 'newzealand', lat: -36.8485, lon: 174.7633, planet_id: 5 },
  { slug: 'saopaulo', cityTag: 'saopaulo', regionTag: 'brazil', lat: -23.5505, lon: -46.6333, planet_id: 6 },
  { slug: 'buenosaires', cityTag: 'buenosaires', regionTag: 'argentina', lat: -34.6037, lon: -58.3816, planet_id: 6 },
  { slug: 'lima', cityTag: 'lima', regionTag: 'peru', lat: -12.0464, lon: -77.0428, planet_id: 6 },
  { slug: 'mexicocity', cityTag: 'mexicocity', regionTag: 'mexico', lat: 19.4326, lon: -99.1332, planet_id: 2 },
  { slug: 'toronto', cityTag: 'toronto', regionTag: 'canada', lat: 43.6532, lon: -79.3832, planet_id: 2 },
  { slug: 'vancouver', cityTag: 'vancouver', regionTag: 'canada', lat: 49.2827, lon: -123.1207, planet_id: 2 },
  { slug: 'losangeles', cityTag: 'losangeles', regionTag: 'usa', lat: 34.0522, lon: -118.2437, planet_id: 2 },
  { slug: 'sanfrancisco', cityTag: 'sanfrancisco', regionTag: 'usa', lat: 37.7749, lon: -122.4194, planet_id: 2 },
  { slug: 'chicago', cityTag: 'chicago', regionTag: 'usa', lat: 41.8781, lon: -87.6298, planet_id: 2 },
  { slug: 'miami', cityTag: 'miami', regionTag: 'usa', lat: 25.7617, lon: -80.1918, planet_id: 2 },
  { slug: 'cairo', cityTag: 'cairo', regionTag: 'egypt', lat: 30.0444, lon: 31.2357, planet_id: 7 },
  { slug: 'capetown', cityTag: 'capetown', regionTag: 'africa', lat: -33.9249, lon: 18.4241, planet_id: 7 },
  { slug: 'nairobi', cityTag: 'nairobi', regionTag: 'africa', lat: -1.2921, lon: 36.8219, planet_id: 7 },
  { slug: 'lagos', cityTag: 'lagos', regionTag: 'africa', lat: 6.5244, lon: 3.3792, planet_id: 7 },
  { slug: 'istanbul', cityTag: 'istanbul', regionTag: 'turkey', lat: 41.0082, lon: 28.9784, planet_id: 4 },
  { slug: 'moscow', cityTag: 'moscow', regionTag: 'russia', lat: 55.7558, lon: 37.6173, planet_id: 8 },
  { slug: 'beijing', cityTag: 'beijing', regionTag: 'china', lat: 39.9042, lon: 116.4074, planet_id: 9 },
  { slug: 'shanghai', cityTag: 'shanghai', regionTag: 'china', lat: 31.2304, lon: 121.4737, planet_id: 9 },
  { slug: 'hongkong', cityTag: 'hongkong', regionTag: 'china', lat: 22.3193, lon: 114.1694, planet_id: 9 },
  { slug: 'taipei', cityTag: 'taipei', regionTag: 'taiwan', lat: 25.033, lon: 121.5654, planet_id: 9 },
  { slug: 'jakarta', cityTag: 'jakarta', regionTag: 'indonesia', lat: -6.2088, lon: 106.8456, planet_id: 4 },
  { slug: 'manila', cityTag: 'manila', regionTag: 'philippines', lat: 14.5995, lon: 120.9842, planet_id: 4 },
  { slug: 'busan', cityTag: 'busan', regionTag: 'korea', lat: 35.1796, lon: 129.0756, planet_id: 1 },
  { slug: 'jeju', cityTag: 'jeju', regionTag: 'korea', lat: 33.4996, lon: 126.5312, planet_id: 1 },
  { slug: 'oslo', cityTag: 'oslo', regionTag: 'nordics', lat: 59.9139, lon: 10.7522, planet_id: 3 },
  { slug: 'stockholm', cityTag: 'stockholm', regionTag: 'nordics', lat: 59.3293, lon: 18.0686, planet_id: 3 },
  { slug: 'helsinki', cityTag: 'helsinki', regionTag: 'nordics', lat: 60.1699, lon: 24.9384, planet_id: 3 },
  { slug: 'lisbon', cityTag: 'lisbon', regionTag: 'portugal', lat: 38.7223, lon: -9.1393, planet_id: 3 },
  { slug: 'athens', cityTag: 'athens', regionTag: 'greece', lat: 37.9838, lon: 23.7275, planet_id: 3 },
  { slug: 'reykjavik', cityTag: 'reykjavik', regionTag: 'nordics', lat: 64.1466, lon: -21.9426, planet_id: 3 },
  { slug: 'marrakech', cityTag: 'marrakech', regionTag: 'africa', lat: 31.6295, lon: -7.9811, planet_id: 7 },
  { slug: 'seoul-gangnam', cityTag: 'gangnam', regionTag: 'korea', lat: 37.4979, lon: 127.0276, planet_id: 1 },
];

export const BOARD_THEME_SUFFIXES = [
  'morning-coffee',
  'lunch-spots',
  'after-work',
  'weekend-walks',
  'late-night-eats',
  'brunch-club',
  'dog-parks',
  'cat-cafe',
  'flea-markets',
  'grocery-run',
  'bus-commute',
  'bike-routes',
  'rainy-day',
  'sunset-views',
  'study-nooks',
  'bookstores',
  'room-makeover',
  'picnic-spots',
  'date-night',
  'family-outing',
  'happy-hour',
  'karaoke-night',
  'hot-spring',
  'night-market',
  'street-food',
  'bakery-run',
  'flower-shops',
  'thrift-finds',
  'laundry-day',
  'meal-prep',
];

/** Global boards (no GPS) — everyday life themes for mock diversity. */
export const GLOBAL_EVERYDAY_BOARDS = [
  'morning-routine',
  'commute-stories',
  'lunch-break-chat',
  'after-work-wind-down',
  'weekend-brunch',
  'late-night-snacks',
  'grocery-finds',
  'meal-prep-tips',
  'pet-parents',
  'plant-corner',
  'apartment-setup',
  'laundry-day',
  'gym-checkins',
  'running-log',
  'book-club',
  'study-cafe',
  'rainy-day-mood',
  'sunny-picnic',
  'thrift-hauls',
  'budget-meals',
  'date-ideas',
  'solo-walks',
  'kid-friendly',
  'neighbors-help',
  'coffee-orders',
  'playlist-share',
  'photo-dump',
  'app-wishlist',
  'daily-gratitude',
  'work-from-home',
  'side-hustle',
  'roommate-life',
];

/** Pick a unique everyday board name for non-geo expansion copies. */
export function globalBoardName(copyIndex, boardId, baseCount) {
  const idx = (copyIndex * baseCount + boardId) % GLOBAL_EVERYDAY_BOARDS.length;
  return GLOBAL_EVERYDAY_BOARDS[idx];
}

/** Pick a geo board theme suffix for expansion copies. */
export function geoBoardTheme(boardId, copyIndex) {
  const idx = (boardId + copyIndex * 5) % BOARD_THEME_SUFFIXES.length;
  return BOARD_THEME_SUFFIXES[idx];
}

export const EXTRA_TOPIC_TAGS = [
  'streetfood',
  'architecture',
  'festival',
  'sunset',
  'localtips',
  'weekend',
  'rainyday',
  'sunny',
  'hidden_gem',
  'photospot',
  'family',
  'solo_travel',
  'budget',
  'luxury',
  'night_market',
  'brunch',
];

/** Pick a world anchor for a given expansion copy + slot (entity id). */
export function anchorForCopy(copyIndex, slot = 0) {
  const idx = (copyIndex * 11 + slot * 3) % WORLD_ANCHORS.length;
  return WORLD_ANCHORS[idx];
}

/** Small offset around an anchor so entities in the same city don't stack. */
export function jitterAround(lat, lon, seed, spreadDeg = 0.07) {
  const a = seed * 0.6180339887;
  const b = seed * 0.3141592653;
  return {
    lat: Number((lat + Math.sin(a) * spreadDeg).toFixed(6)),
    lon: Number((lon + Math.cos(b) * spreadDeg).toFixed(6)),
  };
}
